module.exports = __webpack_public_path__ + "img/img_6.b1468bb3.jpg";